import { useState } from "react";

import { useAnimationFrame } from "framer-motion";

/**
 * @param {import("react").Ref} ref
 * @returns {number}
 */
const useWidth = (ref) => {
  const [width, setWidth] = useState(ref.current?.clientWidth);

  // Resize observer proved to be unreliable. Do not be fooled!
  useAnimationFrame(() => {
    const newWidth =
      ref.current?.clientWidth ||
      ref.current?.getBoundingClientRect().right -
        ref.current?.getBoundingClientRect().left;
    if (width !== newWidth) setWidth(newWidth || 0);
  });

  return width;
};

export default useWidth;
